import { get } from 'microcosm'

const BREAKPOINTS = [
  { name: 'small', width: 600 },
  { name: 'large', width: Infinity }
]

export function getBreakpoint(width) {
  let match = BREAKPOINTS.filter(b => b.width >= width).shift()

  return get(match, 'name', BREAKPOINTS[0].name)
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/breakpoints.js